import { Vehicle } from 'core/models/vehicle';
import { Gear } from 'core/models/drive';
import { useState, useEffect } from 'react';
import { useVehicleRepository } from './useVehicleRepository';
import { VehicleStatusError } from 'core/repositories/VehicleRepository';
import { Project } from 'core/models/project';

export function useVehicleStatusError(): VehicleStatusError | undefined {
    const repository = useVehicleRepository();

    const [error, setError] = useState<VehicleStatusError>();

    useEffect(() => {
        if (!repository) {
            return;
        }

        const listener = (error: VehicleStatusError) => {
            console.error('vehicle status error', error);
            setError(error);
        };

        try {
            console.log('an error listener added');
            repository.addVehicleStatusErrorListener(listener);

            return () => {
                repository.removeVehicleStatusErrorListener(listener);
            };
        } catch (e) {
            console.error(`cannot start listening vehicle status due to: ${JSON.stringify(e)}`);
            return () => { /* nothing to do */ };
        }
    }, [repository]);

    return error;
}

export function useVehicleStatus(vehicleId: Vehicle.Id, projectId: Project.Id): Vehicle.Status {
    const repository = useVehicleRepository();

    const [vehicleStatus, setVehicleStatus] = useState<Vehicle.Status>({
        currentSpeed: 0,
        targetSpeed: 0,
        stateMessage: '',
        steering: 0,
        accel: 0,
        brake: 0,
        gear: Gear.P,
        blinker: null,
    });

    useEffect(() => {
        if (!repository) {
            return;
        }

        const listener = (vehicleStatus: Vehicle.Status) => {
            setVehicleStatus(vehicleStatus);
        };
        try {
            repository.addVehicleStatusListener(vehicleId, projectId, listener);

            return () => {
                repository.removeVehicleStatusListener(vehicleId, projectId, listener);
            };
        } catch (e) {
            console.error(`cannot start listening vehicle status due to: ${JSON.stringify(e)}`);
            return () => { /* nothing to do */ };
        }
    }, [repository, vehicleId, projectId]);

    return vehicleStatus;
}
